import { fetchPaxsGroup, fetchPax, inviteTravelTogether, modifyGroupPax, scanStrToPax } from '@/api/passenger'
const sendInviteTravelTogether = (context, params) => {
  return inviteTravelTogether(params).then((response) => {
    return response
  })
}

const reFetchPax = () => {
  return fetchPax().then((response) => {
    return response
  })
}

const reFetchPaxGroup = ({ commit }) => {
  return fetchPaxsGroup().then((response) => {
    commit('GET_PAXS_GROUP', response, { root: true })
    return response
  })
}

const handleModifyGroupPax = (context, params) => {
  return modifyGroupPax(params).then((response) => {
    return response
  })
}

const cuteScanStrToPax = (context, data) => {
  return scanStrToPax(data).then((response) => {
    return response
  })
}

export default {
  sendInviteTravelTogether,
  reFetchPax,
  reFetchPaxGroup,
  handleModifyGroupPax,
  cuteScanStrToPax
}
